'use strict';

import SearchSwitchTriple from "../components/SearchSwitchTriple";

function SearchSwitchTripleWidget({
    type,
    onChangeType,
    planesCount,
    seatsCount,
    toursCount,
    useLocalStorageCounters,
    setSearchScenario = false,
}) {
    const [counters, setCounters] = React.useState({ planesCount, seatsCount, toursCount });
    
    React.useEffect(() => listenEvent('storage.reactSearchData', () => {
        const data = typeof storageGetActualSearchData === 'function' ? storageGetActualSearchData() : null;
        if (!data) return;
        setCounters(current => ({
            planesCount: 'planesCount' in data ? (data.planesCount || 0) : current.planesCount,
            seatsCount: 'seatsCount' in data ? (data.seatsCount || 0) : current.seatsCount,
            toursCount: 'toursCount' in data ? (data.toursCount || 0) : current.toursCount,
        }));
    }), []);

    return (
        <SearchSwitchTriple
            type={type}
            onChangeType={onChangeType}
            planesCount={counters.planesCount}
            seatsCount={counters.seatsCount}
            toursCount={counters.toursCount}
            useLocalStorageCounters={useLocalStorageCounters}
            setSearchScenario={setSearchScenario}
        />
    )
}

window.SearchSwitchTripleWidget = SearchSwitchTripleWidget;
